export const getStyles = () => ({
  pastResultsContainer: {
    backgroundColor: "#E1E1FF",
  },
  pastResultsSection: {
    display: "grid",
    position: "relative",
    gridTemplateColumns: "repeat(6, calc(100% / 6))",
    gridTemplateRows: "auto 1fr",
    minHeight: "350px",

    "& h2": {
      gridColumn: "1 / -1",
      paddingInline: "40px",
      textAlign: "center",
      fontWeight: 700,
      color: "#F4364C",
      marginBlock: "20px",
      fontSize: "1.25rem",
      zIndex: 2,

      "@media (min-width: 960px)": {
        fontSize: "2.5rem",
        marginTop: "108px",
        marginBottom: "108px",
      },
    },

    "@media (min-width: 960px)": {
      gridColumn: "2 / -2",
      minHeight: "700px",
    },
  },
  pastResultsImage: {
    height: "72px",

    "& img[alt='girl-reading-illustration']": {
      height: "auto",
      objectFit: "contain",
      position: "absolute",
      left: "-16px",
      bottom: "-20px",
      width: "132px",
      gridColumn: "1 / 3",
      zIndex: 1,

      "@media (min-width: 600px)": {
        width: "200px",
      },
      "@media (min-width: 960px)": {
        width: "408px",
        bottom: "-40px",
      },
    },
    "& img[alt='books-illustration']": {
      height: "100%",
      objectFit: "contain",
      position: "absolute",
      inset: 0,
      gridColumn: "1 / -1",
      gridRow: "3 / -1",
      paddingLeft: "132px", // first image width

      "@media (min-width: 600px)": {
        paddingLeft: "200px",
      },
      "@media (min-width: 960px)": {
        paddingLeft: "408px",
      },
    },

    "@media (min-width: 600px)": {
      height: "100px",
    },
    "@media (min-width: 960px)": {
      height: "250px",
    },
  },
  pastResultsStatsContainer: {
    position: "relative",
    display: "inline-flex",
    justifyContent: "center",
    alignItems: "center",
    flexWrap: "wrap",
    gap: "48px",
    zIndex: 2,
    marginRight: "24px",
    marginBottom: "24px",
    gridColumn: "3 / -1",

    "@media (min-width: 960px)": {
      marginBottom: "54px",
    },
  },
  pastResultsStats: {
    textAlign: "center",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "12px",

    "& h4": {
      fontSize: "1.25rem",
      fontWeight: 700,
    },
    "& p": {
      fontSize: "0.875rem",
    },
    "@media (min-width: 960px)": {
      gap: 0,
      "& h4": {
        fontSize: "3.75rem",
      },
      "& p": {
        fontSize: "1.5rem",
      },
    },
  },
});
